/**
 * Takes currency number values and manipulates them, e.g. display as $100
 * Can deal with decimals or ints (ints represent smallest unit, ie cents)
 */
class Currency {
  value: number;

  constructor(value?: number) {
    this.value = value || 0;
    return this;
  }

  static fromDecimal = (value: number | string) => {
    return new Currency(Number(value));
  };

  static fromInt(value: number | string) {
    return new Currency((Number(value) * 1.0) / 100);
  }

  dollars() {
    return this.formatDollars().replace(/\.[0-9]{2}$/, "");
  }

  cents() {
    return this.formatDollars().replace(/^.*(\.[0-9]{2})$/, "$1");
  }

  formatDollars() {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(this.value);
  }

  formatAsTextInMillions() {
    const value = this.value / 10 ** 6;
    return `$${value} million`;
  }
}

export default Currency;
